import img from "../assets/img/kopilibrasi_home.png";
import BgPng from "../assets/img/coffee-beans-bg.png";
import { motion } from "framer-motion";

export default function Home() {
    const backgroundStyle = {
        backgroundImage: `url(${BgPng})`,
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        height: "100%",
        width: "100%",
    };
    const productVariant = {
        visible: {
            opacity: 1,
            scale: 1,
            transition: {
                duration: 0.5,
            }
        },
        hidden: {
            opacity: 0,
            scale: 0
        }
    }

    return (
        // <div className="flex flex-col justify-center lg:flex-row py-10 md:py-14 lg:justify-between items-center lg:px-32 px-5 gap-10 bg-gradient-to-r from-[#dfe56c] to-[#767d1c] ">
        <div style={backgroundStyle} className="flex flex-col justify-center lg:flex-row py-10 md:py-14 lg:justify-between items-center lg:px-32 px-5 gap-10 ">
            <div className=" w-full lg:w-2/4 space-y-4 lg:mt-0">
                <h1 className="text-white font-semibold text-3xl md:text-5xl text-center lg:text-start leading-tight font-cursive2">
                    Start your day with a steaming cup of coffee
                </h1>
                <p className="text-white font-cursive tracking-wider">
                    "Ketika orang perlu interaksi, literasi & Kolaborasi"
                </p>
            </div>
            <div className="relative">
                <motion.div
                    variants={productVariant}
                    initial="hidden"
                    animate="visible"
                >
                    <img width={240} src={img} alt="img" />
                </motion.div>

                <div className="absolute px-8 py-2 top-5 right-0 rounded-full shadow-[0_20px_50px_rgba(8,_112,_184,_0.7)] bg-[#E8b109]">
                    <h2 className="font-semibold">Start From 15K</h2>
                </div>

                <div className="absolute px-8 py-2 bottom-0 -left-10 rounded-full bg-[#E8b109]">
                    <h2 className="font-semibold">Kopilibrasi</h2>
                </div>
            </div>
        </div>

    )
}